// Components
import { Button, IconLock, Tooltip } from '@tracklib/kit'

import styles from './paybutton.css'

interface PayButtonProps {
  buttonText: string
  onClick: () => void
  isLoading: boolean
  hideSecure?: boolean
  disabled?: boolean
}

const PayButton = ({ disabled, isLoading, onClick, buttonText, hideSecure }: PayButtonProps) => {
  return (
    <>
      <Button isLoading={isLoading} disabled={disabled || isLoading} className={styles.payButton} onClick={onClick} datatesting="paybutton">
        {buttonText}
      </Button>
      {!hideSecure && (
        <div className={styles.secureNoteContainer}>
          <div className={styles.secureNote} data-tooltip-wrapper>
            <IconLock /> Secure checkout
            <Tooltip className={styles.tooltip}>All transactions are secure and encrypted</Tooltip>
          </div>
        </div>
      )}
    </>
  )
}

export default PayButton
